import React from 'react'
import ga from 'react-ga'
import lscache from "lscache"
import { isProducao } from './config/Constantes'

const enable = isProducao;
const gaId = process.env.rig ? 'UA-157868435-1' : 'UA-39463945-2'
if (enable) ga.initialize(gaId);

export default Component =>
  class WithAnalytics extends React.Component {
    componentDidMount() {
      const page = this.props.location.pathname;
      this.trackPage(page);
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;
      const updated = (currentPage !== nextPage)
      if (updated) this.trackPage(nextPage);
    }

    trackPage = page => {
      if (enable) {
        ga.set({ page });
        ga.pageview(page);

        const id = lscache.get('MembershipuserId')
        console.log(id)
        if (id) ga.set({ userId: id });
      }
    };

    render() {
      return <Component {...this.props} />;
    }
  };


// WEBPACK FOOTER //
// ./src/Analytics.js